class AccordionItem extends HTMLElement {
  connectedCallback() {
    this.querySelector(".acc-trigger")?.addEventListener("click", () =>
      this.toggle()
    );

    this.querySelector(".acc-indicator")?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggle()
    });
  }
  toggle(force) {
    const btn = this.querySelector(".acc-trigger");
    const panel = this.querySelector(".acc-panel");
    const open = force ?? btn.getAttribute("aria-expanded") !== "true";
    btn.setAttribute("aria-expanded", open);
    panel.setAttribute("aria-hidden", !open);
    if (open) {
      const group = this.closest("accordion-group");
      if (group?.hasAttribute("exclusive"))
        group
          .querySelectorAll("accordion-item")
          .forEach((i) => i !== this && i.toggle(false));
    }
  }
}
customElements.define("accordion-item", AccordionItem);
